import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { postApi } from "./http";

export function loadAuth() {
  const user = Vue.ls.get("user");
  setAuth(user);
}

export function setAuth(user) {
  if (user && user.userUID) Vue.ls.set("user", user);
  else Vue.ls.clear();

  store.commit("auth/set", user);
}

export async function logout(skipApiCall) {
  try {
    if (!skipApiCall) {
      try {
        await postApi("logout");
      } catch (err) {
        console.error(err);
      }
    }

    setAuth({});
    reroute();
    store.commit("computer/clear");
    store.commit("computerPackage/clear");
    store.commit("domain/clear");
    store.commit("group/clear");
    store.commit("groupPackage/clear");
    store.commit("powershell/clear");
    store.commit("socket/clear");
    store.commit("source/clear");
    store.commit("settings/clear");
  } catch (err) {
    console.log(err);
  }
}

export function reroute() {
  if (!store.state.auth.success && router.currentRoute.path != "/signin")
    router.push({
      path: "/signin",
    });
  else
    router.push({
      path: "/domains",
    });
}
